if (!customElements.get('avel-guided-tutorial')) {
  customElements.define('avel-guided-tutorial', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.addEventListener('click', (event) => {
        const link = event.target.closest('[data-play]');
        if (!link || !this.contains(link)) return;
        const player = this.querySelector('[data-player]');
        if (!player) return;
        const seconds = Math.max(0, Math.floor(Number(link.dataset.play) || 0));
        if (this.dataset.videoSource === 'shopify') {
          const template = this.querySelector('[data-video-template]');
          if (!template) return;
          event.preventDefault();
          let video = player.querySelector('video');
          if (!video) {
            player.replaceChildren(template.content.cloneNode(true));
            video = player.querySelector('video');
          }
          if (!video) return;
          video.setAttribute('aria-label', this.dataset.videoTitle || this.dataset.videoFallbackTitle);
          this.pendingSeconds = seconds;
          const seek = () => {
            const end = Number.isFinite(video.duration) ? Math.max(0, video.duration - 0.1) : this.pendingSeconds;
            video.currentTime = Math.min(this.pendingSeconds, end);
          };
          if (video.readyState >= 1) seek();
          else video.addEventListener('loadedmetadata', seek, { once: true, signal: this.abort.signal });
          video.play().catch(() => { /* Native controls remain available if autoplay is blocked. */ });
          video.focus();
          return;
        }
        const id = this.dataset.videoId;
        if (!/^[a-zA-Z0-9_-]{11}$/.test(id || '')) return;
        event.preventDefault();
        const frame = document.createElement('iframe');
        frame.title = this.dataset.videoTitle || this.dataset.videoFallbackTitle;
        frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        frame.allowFullscreen = true;
        frame.src = `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&playsinline=1&rel=0&start=${seconds}`;
        player.replaceChildren(frame);
        frame.focus();
      }, options);
      this.querySelectorAll('details').forEach((step) => {
        step.addEventListener('toggle', () => {
          if (step.open) this.querySelectorAll('details').forEach((other) => {
            if (other !== step) other.open = false;
          });
        }, options);
      });
      document.addEventListener('shopify:block:select', (event) => {
        const step = event.target.closest('details');
        if (step && this.contains(step)) step.open = true;
      }, options);
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}
